// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"df187cbfd2fe25647463","655":"ab982fe94ba494a678d4"}[chunkId] + ".js";
};